import { PaletteMode } from "@mui/material";
import { grey } from "@mui/material/colors";

const getBackground = (theme: PaletteMode) => {
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

	switch(theme){
		case 'light':
			return isMobile ? 'transparent' : grey[50]
		case 'dark':
			return isMobile ? 'transparent' : grey[900]
		default:
			return 'transparent'
	}
}

const getBorder = (theme: PaletteMode) => {
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

	switch(theme){
		case 'light':
			return isMobile ? 'none' : '1px solid rgba(0, 0, 0, 0.12)'
		case 'dark':
			return isMobile ? 'none' : '1px solid rgba(255, 255, 255, 0.12)'
		default:
			return 'none'
	}

}

const getAvatar = (string: string) => {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

export {
    getBackground,
    getBorder,
	getAvatar
}